import { useState, useEffect } from "react";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import ChatPanel from "./pages/ChatPanel";
import VoicePanel from "./pages/VoicePanel";
import VisionPanel from "./pages/VisionPanel";
import Toast from "./components/Toast";
import "./App.css";

export const API =
  "https://khizerarena77-538996436878.us-central1.run.app";

export default function App() {

  const [activePanel, setActivePanel] = useState("chat");
  const [modesVisible, setModesVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  /* Chat state stored globally so it never resets */
  const [chatMessages, setChatMessages] = useState([
    {
      role: "ai",
      text:
        "Hello. I'm your medical AI assistant. Please describe your symptoms or ask a health-related question, and I'll provide safe, general guidance."
    }
  ]);

  /* Detect mobile screen */
  useEffect(() => {

    const checkMobile = () => {

      const mobile = window.innerWidth <= 768;

      setIsMobile(mobile);

      if (mobile) {
        setModesVisible(false);
      } else {
        setModesVisible(true);
      }

    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);

  }, []);

  /* Toast system */

  const [toast, setToast] = useState({
    msg: "",
    type: "",
    visible: false
  });

  const showToast = (msg, type = "") => {

    setToast({
      msg,
      type,
      visible: true
    });

    setTimeout(() => {
      setToast(t => ({
        ...t,
        visible: false
      }));
    }, 3200);

  };

  /* Sidebar selection */

  const handleSelect = (id) => {

    setActivePanel(id);

    /* Close sidebar on mobile after selecting */
    if (isMobile) {

      setTimeout(() => {
        setModesVisible(false);
      }, 200);

    }

  };

  return (

    <div className="app-root">

      {/* Ambient background */}

      <div className="ambient ambient-1" />
      <div className="ambient ambient-2" />

      {/* Header */}

      <Header
        modesVisible={modesVisible}
        onToggleModes={() => setModesVisible(v => !v)}
      />

      {/* Mobile overlay */}

      {isMobile && modesVisible && (
        <div
          className="mobile-overlay"
          onClick={() => setModesVisible(false)}
        />
      )}

      {/* Layout */}

      <div className="layout">

        <Sidebar
          active={activePanel}
          onSelect={handleSelect}
          modesVisible={modesVisible}
        />

        <main className="main">

  {activePanel === "chat" && (
    <ChatPanel
      messages={chatMessages}
      setMessages={setChatMessages}
      showToast={showToast}
    />
  )}

  {activePanel === "voice" && (
    <VoicePanel showToast={showToast} />
  )}

  {activePanel === "vision" && (
    <VisionPanel showToast={showToast} />
  )}

</main>


      </div>

      {/* Toast */}

      <Toast
        msg={toast.msg}
        type={toast.type}
        visible={toast.visible}
      />

    </div>

  );

}
